import type { EffectiveRolesResponse } from '../../types/effectiveRoles.types'

// The effective roles behind mockAssignedDomainsResponse: the inferred grants
// reader comes through a nested group.
export const mockEffectiveRolesResponse: EffectiveRolesResponse = [
  {
    id: 'donations',
    area: 'Finance',
    name: 'Donations',
    roles: [{ id: 'reader', name: 'Reader', sources: [{ type: 'direct' }] }],
  },
  {
    id: 'grants',
    area: 'Grants',
    name: 'Grants',
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        sources: [
          {
            type: 'group',
            group: { id: 'group_finance', name: 'Finance team' },
            path: [
              { id: 'group_payments', name: 'Payments' },
              { id: 'group_finance', name: 'Finance team' },
            ],
          },
        ],
      },
      { id: 'reviewer', name: 'Reviewer', sources: [{ type: 'direct' }] },
    ],
  },
]
